import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Download, MessageSquare, User, Calendar, Eye, ShoppingBag } from "react-feather";
import { Spinner, Badge, Modal, Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";

const AdminSellerQuote = () => {
  const [inquiries, setInquiries] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Modal State for viewing full details
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const response = await axios.get(`${baseurl}FetchAllInquiriesForAdmin`);
        if (response.data.success) {
          setInquiries(response.data.inquiries);
          setFilteredData(response.data.inquiries);
        }
      } catch (error) {
        console.error("Error fetching admin inquiries:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInquiries();
  }, []);

  const handleDownloadExcel = () => {
    const exportData = filteredData.map(item => ({
      Inquiry_ID: item.cart_id,
      Product: item.product_title,
      Customer: `${item.cust_first_name} ${item.cust_last_name}`,
      Customer_Email: item.cust_email,
      Seller: `${item.seller_first_name} ${item.seller_last_name}`,
      Seller_Email: item.seller_email,
      Quantity: item.quantity,
      Date: new Date(item.added_at).toLocaleString(),
      Remark: item.remark
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Seller Inquiries");
    XLSX.writeFile(wb, "seller_inquiries_report.xlsx");
  };

  const handleView = (item) => {
    setSelected(item);
    setShowModal(true);
  };

  return (
    <div className="App d-flex" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      <AdminSidebar />
      <div className="content flex-grow-1 p-4">
        <AdminTopbar />
        
        <div className="container-fluid mt-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1">Seller Quote Inquiries</h3>
              <p className="text-muted">Monitoring interactions between buyers and sellers</p>
            </div>
            <button className="btn btn-success shadow-sm" onClick={handleDownloadExcel}>
              <Download size={18} className="me-2"/> Export Inquiries
            </button>
          </div>

          <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="card-body p-0">
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2 text-muted">Loading inquiries...</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="bg-light text-secondary small text-uppercase fw-bold">
                      <tr>
                        <th className="ps-4">Product Info</th>
                        <th>Customer (Buyer)</th>
                        <th>Seller (Vendor)</th>
                        <th>Quantity</th>
                        <th>Status</th>
                        <th>Date</th>
                        <th className="text-center pe-4">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length === 0 ? (
                        <tr><td colSpan="7" className="text-center py-5">No inquiries found</td></tr>
                      ) : (
                        filteredData.map((item) => (
                          <tr key={item.cart_id}>
                            <td className="ps-4">
                              <div className="d-flex align-items-center">
                                <img 
                                  src={`${imageUrl}listing/${item.product_image}`} 
                                  alt="" 
                                  className="rounded-2 border" 
                                  style={{ width: "45px", height: "45px", objectFit: "cover" }}
                                  onError={(e) => e.target.src = 'https://via.placeholder.com/45'}
                                />
                                <div className="ms-3">
                                  <div className="fw-bold text-dark small">{item.product_title}</div>
                                  <div className="text-muted extra-small">ID: #{item.listing_id}</div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="small fw-semibold">{item.cust_first_name} {item.cust_last_name}</div>
                              <div className="text-muted small">{item.cust_email}</div>
                            </td>
                            <td>
                              <div className="small fw-semibold">{item.seller_first_name} {item.seller_last_name}</div>
                              <div className="text-muted small">{item.seller_email}</div>
                            </td>
                            <td><Badge bg="secondary" pill>{item.quantity}</Badge></td>
                            <td>
                              <Badge bg={item.seller_status === "Active" ? "success" : "warning"} className="text-capitalize">
                                {item.seller_status}
                              </Badge>
                            </td>
                            <td className="small text-muted">
                              {new Date(item.added_at).toLocaleDateString('en-GB')}
                            </td>
                            <td className="text-center pe-4">
                              <button className="btn btn-sm btn-outline-primary" onClick={() => handleView(item)}>
                                <Eye size={16} />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Detail Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="h5 fw-bold">Inquiry # {selected?.cart_id}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {selected && (
            <div className="row g-4">
              <div className="col-md-6">
                <h6 className="text-primary fw-bold mb-3 d-flex align-items-center">
                  <User size={18} className="me-2"/> Participants
                </h6>
                <div className="p-3 bg-light rounded-3 mb-3">
                  <label className="text-muted small d-block">Buyer Details</label>
                  <strong>{selected.cust_first_name} {selected.cust_last_name}</strong>
                  <div className="small">{selected.cust_email}</div>
                </div>
                <div className="p-3 bg-light rounded-3">
                  <label className="text-muted small d-block">Seller Details</label>
                  <strong>{selected.seller_first_name} {selected.seller_last_name}</strong>
                  <div className="small">{selected.seller_email}</div>
                </div>
              </div>

              <div className="col-md-6">
                <h6 className="text-primary fw-bold mb-3 d-flex align-items-center">
                  <ShoppingBag size={18} className="me-2"/> Product & Remark
                </h6>
                <div className="card border p-3">
                  <div className="fw-bold mb-1">{selected.product_title}</div>
                  <div className="text-muted small mb-2">Quantity Requested: {selected.quantity}</div>
                  <hr className="my-2"/>
                  <label className="text-muted small d-block italic">Customer Message:</label>
                  <p className="mb-0 small bg-white p-2 rounded border">{selected.remark || "No remarks provided"}</p>
                </div>
              </div>

              <div className="col-12">
                <h6 className="text-success fw-bold mb-3 d-flex align-items-center">
                  <MessageSquare size={18} className="me-2"/> Seller Response History
                </h6>
                <div className="timeline-container bg-light p-3 rounded-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {selected.seller_responses && selected.seller_responses.length > 0 ? (
                    selected.seller_responses.map((res, idx) => (
                      <div key={idx} className="mb-3 border-start border-primary border-3 ps-3">
                        <div className="d-flex justify-content-between small">
                          <span className="fw-bold text-primary">Response {idx + 1}</span>
                          <span className="text-muted">{new Date(res.sent_at).toLocaleString()}</span>
                        </div>
                        <div className="small mt-1">{res.message}</div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-3 text-muted small">No responses from seller yet</div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .extra-small { font-size: 0.7rem; }
        .italic { font-style: italic; }
      `}</style>
    </div>
  );
};

export default AdminSellerQuote;